module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Fish-7f0776a66280fb6fea8d87d50c931910.svg";